import ReactGA from "react-ga";
import { ENV } from "../../config";

const trackingId = "UA-163799480-1";

if (ENV === "production") {
  ReactGA.initialize(trackingId);
}
